const tokenName = 'nxz_token'

export function setToken (token) {
  return localStorage.setItem(tokenName, token)
}

// 获取token
export function getToken () {
  return localStorage.getItem(tokenName)
}

// 清空token
export function clearToken () {
  return localStorage.removeItem(tokenName)
}
// object 转为字符串
export function setSessionStorage (name, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  return sessionStorage.setItem(name, value)
}
// 获取sessionStorage对象
export function getStorage (name) {
  return sessionStorage.getItem(name)
}
// 获取json字符串并转换为json对象
export function getSessionObjectStorage (name) {
  return JSON.parse(sessionStorage.getItem(name))
}
// 永久存储
export function setLocalStorage (name, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  return localStorage.setItem(name, value)
}
export function getLocalStorage (name) {
  return localStorage.getItem(name)
}
export function getLocalObjectStorage (name) {
  let value = getLocalStorage(name)
  if (value) {
    return JSON.parse(value)
  } else{
    return {}
  }
}

// 时间转换
export function dayTime (time) {
  let newTime = time.replace(/\-/g, '/')
  let date = Math.round(new Date() / 1000)
  let date2 = Math.round(new Date(newTime) / 1000)
  let diffDate = date - date2
  let t = 0
  let newDate = new Date(newTime)
  if (diffDate / (60 * 60 * 24) >= 1) {
    let month = newDate.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let day = newDate.getDate()
    day = day < 10 ? '0' + day : day
    let hours = newDate.getHours()
    let minutes = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes()
    t = month + '-' + day + ' ' + hours + ':' + minutes
  } else {
    let minutes = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes()
    t = newDate.getHours() + ':' + minutes
  }
  return t
}

// 获取日期
export function getFormatDate (date, type) {
  let currentDate = new Date(date)
  if (type === 'y') {
    return `${currentDate.getFullYear()}`
  } else if (type === 'ym') {
    let month = currentDate.getMonth() + 1
    month = month < 10 ? '0'+ month : month
    return `${currentDate.getFullYear()}/${month}`
  } else if (type === 'ymd') {
    let month = currentDate.getMonth() + 1
    month = month < 10 ? '0'+ month : month
    let day = currentDate.getDate()
    day = day < 10 ? '0'+ day : day
    return `${currentDate.getFullYear()}/${month}/${day}`
  } else if (type === 'md') {
    let month = currentDate.getMonth() + 1
    month = month < 10 ? '0'+ month : month
    let day = currentDate.getDate()
    day = day < 10 ? '0'+ day : day
    return `${month}/${day}`
  }
}

/**
 * ymd ymt ym yd yw yW md mt
 * 获取月份最后一天
 */
export function monthLastDay(y = null, m = null)
{
  let date = new Date()
  let year = y ? y : date.getFullYear()
  let month = m ? m - 1 : date.getMonth()

  let startDate = new Date(year, month, 1);
  let startDateTime = startDate.getTime()
  startDate.setMonth(startDate.getMonth() + 1);
  let days = (startDate.getTime() - startDateTime) / (24 * 60 * 60* 1000)

  let newMonth = parseInt(month) + 1
  return year + '-' + newMonth + '-' + days
}

/**
 * 获取时:分
 */
export function hm (split = ':') {
  let date = new Date()
  let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  return hour + split + minute
}

/**
 * 获取周
 * @param date
 * @returns {number}
 */
export function yw(date = null) {
  date = new Date(date)
  var date1 = new Date(date.getFullYear(), 0, 1)
  var w1 = date1.getDay()
  // 周日开始 获取第一个周日
  // 周一开始
  if (w1 !== 1) {
    date1 = new Date(date.getFullYear(), 0, 1 + (8 - w1))
  }
  var date2 = new Date(date)
  let allDay = Math.ceil((date2.getTime() - date1.getTime()) / 86400000)
  let week = Math.ceil(allDay / 7)
  return date.getFullYear() + '-' + week
}

export function getYearWeek(week, num = 0) {
  let weekArr = week.split('-')
  if (parseInt(weekArr[1]) + num <= 0) {
    let year = parseInt(weekArr[0]) - 1
    let maxWeek = yw(year + '-' + '12-31')
    let maxWeekArr = maxWeek.split('-')
    let surplusWeek = parseInt(weekArr[1]) + num
    let weekNum = parseInt(maxWeekArr[1]) - parseInt(surplusWeek)
    return maxWeekArr[0] + '-' + weekNum
  } else {
    let weekNum = parseInt(weekArr[1]) + num
    return weekArr[0] + '-' + weekNum
  }
}

/**
 * 获取周开始、结束的日期
 * @param week (yyyy-ww)
 */
export function weekDate(week)
{
  let weekArr = week.split('-')
  // // 总计天数

  let yearStart = new Date(weekArr[0], 0, 1)
  let w1 = yearStart.getDay()
  // 周一开始 获取第一个周一
  // 年度第一周开始日期
  if (w1 !== 1) {
    if (w1 === 0) {
      yearStart = new Date(yearStart.getFullYear(), 0, yearStart.getDate() + 1)
    } else {
      yearStart = new Date(yearStart.getFullYear(), 0, yearStart.getDate() + (8 - w1))
    }
  }
  let allTime = ((parseInt(weekArr[1])) - 2) * 7 * 86400000
  let startDate = new Date(yearStart.getTime() + allTime)
  let endDate = new Date(yearStart.getTime() + allTime + 6 * 86400000)

  let startMonth = startDate.getMonth() + 1
  startMonth = startMonth >= 10 ? startMonth : '0' + startMonth
  let startDay = startDate.getDate()
  startDay = startDay >= 10 ? startDay : '0' + startDay

  let endMonth = endDate.getMonth() + 1
  endMonth = endMonth >= 10 ? endMonth : '0' + endMonth
  let endDay = endDate.getDate()
  endDay = endDay >= 10 ? endDay : '0' + endDay
  return [`${startMonth}/${startDay}`, `${endMonth}/${endDay}`]
}

/**
 * 根据数组键值从小到大排序
 * @param arr
 * @param key
 * @returns {*}
 */
export function sortBykey (arr, key) {
  return arr.sort(function (a, b) {
    let x = a[key]
    let y = b[key]
    return ((x < y) ? -1 : (x > y) ? 1 : 0)
  })
}

/**
 * 更改对象的键值
 * @param obj
 * @param newKey
 * @param oldKey
 * @returns {any}
 */
export function changeObjectKey (obj, newKey, oldKey) {
  let str = JSON.stringify(obj)
  let reg = new RegExp(oldKey, 'g')
  let newStr = str.replace(reg, newKey)
  return JSON.parse(newStr)
}

/**
 * 获取周几
 * @param ymd
 * @returns {*}
 */
export function weekName (ymd = '') {
  let date = ymd ? new Date(ymd) : new Date();
  let week = date.getDay()
  let array = ['日', '一', '二', '三', '四', '五', '六']
  return array[week]
}

/**
 * 获取最近10周
 */
export function getWeekData (weekNumber = 10) {
  let week = [];
  let date = new Date()
  // 获取最近的周一
  let w = date.getDay()
  let oneDay = 86400000
  let newDate;
  if (w !== 1) {
    newDate = new Date(date.getTime() - oneDay * (w - 1) )
  } else {
    newDate = date
  }
  // 近周数据
  for(let i = 0; i < weekNumber; i ++) {
    let startDate = new Date( newDate.getTime() - oneDay * 7 * i)
    let endDate = new Date(startDate.getTime() + oneDay * 6 * 1)

    let yearStart = new Date(startDate.getFullYear(), 0, 1)
    let w1 = yearStart.getDay()
    // 周一开始 获取第一个周一
    // 年度第一周开始日期
    if (w1 !== 1) {
      yearStart = new Date(startDate.getFullYear(), 0, yearStart.getDate() + (8 - w1))
    }
    let allDay = Math.ceil((startDate.getTime() - yearStart.getTime()) / oneDay)
    let allWeek = Math.ceil(allDay / 7) === 0 ? 1 : Math.ceil(allDay / 7)

    let startMonth = startDate.getMonth() + 1
    startMonth = startMonth >= 10 ? startMonth : '0' + startMonth
    let startDay = startDate.getDate()
    startDay = startDay >= 10 ? startDay : '0' + startDay

    let endMonth = endDate.getMonth() + 1
    endMonth = endMonth >= 10 ? endMonth : '0' + endMonth
    let endDay = endDate.getDate()
    endDay = endDay >= 10 ? endDay : '0' + endDay

    allWeek = allWeek < 10 ? '0' + allWeek : allWeek
    week.push({
      name: `${startDate.getFullYear()}年第${allWeek}周(${startMonth}/${startDay}-${endMonth}/${endDay})`,
      value: `${startDate.getFullYear()}/${allWeek}`
    })
  }
  return week
}

// 获取相差日期包括开始和结束
export function diffDateDay(startDate, endDate) {
  let endTime = new Date(endDate).getTime()
  let startTime = new Date(startDate).getTime()
  let diffDay = Math.floor((endTime - startTime) / (24 * 60 * 60 * 1000));
  return Number(diffDay) + 1
}

// 日期格式转换
export function dateFormat(value) {
  let date = new Date(value);
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
}


// WEBPACK FOOTER //
// ./src/function/function.js